import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import Contact from "./sections/Contact";
import Presence from "./sections/Presence";
import SalesTeam from "./sections/SalesTeam";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <Contact />
      <Presence />
      <SalesTeam />
      <Footer />
    </div>;
}